import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e80744e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Which color am I? ")
const _hoisted_2 = {
  class: "flex-centered",
  style: {"height":"100%"}
}

import * as GameTypes from 'types/game.types';
import { ref, shallowRef } from 'vue';
import { useModule } from 'src/modules/modules';
import GameContentArea from '../game-content-area.vue';
import ContrastText from '../contrast-text.vue';
import ColorPicker from '../color-picker.vue';
import { getColorWithSimilarityInRange, getRandomNonUglyColor } from 'util/color-util';
import chroma from 'chroma-js';


export default /*#__PURE__*/_defineComponent({
  __name: 'pick-color',
  emits: ['next', 'fail'],
  setup(__props, { expose, emit }) {

const { game, audio } = useModule();

const color = shallowRef(getRandomNonUglyColor())


const state = ref({
    distanceMin: 49,
    distanceMax: 100,
    gridCount: 16,
    duration: 5000
})

const gridColors = ref<chroma.Color[]>([]);

/**
 * Select from a large number of not similar colors. As difficulty increases, the colors
 * become more similar and the count increases.
 */
const variation1 = () => {
    if (game.matchState.difficulty === 0){
        console.log("Pick Color: Variation 1, Difficulty 0");
        state.value = {
            distanceMin: 35,
            distanceMax: 80,
            gridCount: 12,
            duration: 5000
        }
    } else if (game.matchState.difficulty === 1){ //Add colors, increased similarity
        console.log("Pick Color: Variation 1, Difficulty 1");
        state.value = {
            distanceMin: 25,
            distanceMax: 70,
            gridCount: 16,
            duration: 5000
        }
    } else if (game.matchState.difficulty === 2){ //Add colors, increased similarity
        console.log("Pick Color: Variation 1, Difficulty 2");
        state.value = {
            distanceMin: 30,
            distanceMax: 60,
            gridCount: 25,
            duration: 6000
        }
    } else if (game.matchState.difficulty === 3){ //Add colors
        console.log("Pick Color: Variation 1, Difficulty 3");
        state.value = {
            distanceMin: 25,
            distanceMax: 45,
            gridCount: 30,
            duration: 7000
        }
    } else if (game.matchState.difficulty >= 4){ //Increased similarity
        console.log("Pick Color: Variation 1, Difficulty 4");
        state.value = {
            distanceMin: 10,
            distanceMax: 40,
            gridCount: 30,
            duration: 7000
        }
    }
}

/**
 * Select from a smaller number of very similar colors
 */
const variation2 = () => {
    if (game.matchState.difficulty === 0){
        console.log("Pick Color: Variation 2, Difficulty 0");
        state.value = {
            distanceMin: 15,
            distanceMax: 40,
            gridCount: Phaser.Utils.Array.GetRandom([4, 8]),
            duration: 5000
        }
    } else if (game.matchState.difficulty === 1){
        console.log("Pick Color: Variation 2, Difficulty 1");
        state.value = {
            distanceMin: 13,
            distanceMax: 40,
            gridCount: Phaser.Utils.Array.GetRandom([8, 12]),
            duration: 5000
        }
    } else if (game.matchState.difficulty === 2){
        console.log("Pick Color: Variation 2, Difficulty 2");
        state.value = {
            distanceMin: 15,
            distanceMax: 40,
            gridCount: 16,
            duration: 5000
        }
    } else if (game.matchState.difficulty === 3){
        console.log("Pick Color: Variation 2, Difficulty 3");
        state.value = {
            distanceMin: 12,
            distanceMax: 30,
            gridCount: 20,
            duration: 5000
        }
    } else if (game.matchState.difficulty === 4){
        console.log("Pick Color: Variation 2, Difficulty 4");
        state.value = {
            distanceMin: 5,
            distanceMax: 22,
            gridCount: 4,
            duration: 5000
        }
    } else if (game.matchState.difficulty >= 4){
        console.log("Pick Color: Variation 2, Difficulty 5");
        state.value = {
            distanceMin: 5,
            distanceMax: 15,
            gridCount: 8,
            duration: 5000
        }
    }
}

/**
 * Randomly select a game variation
 */
Phaser.Utils.Array.GetRandom([variation2, variation1])();
for (let i = 0; i < state.value.gridCount; i++){
    gridColors.value.push(
        getColorWithSimilarityInRange(color.value, state.value.distanceMin, state.value.distanceMax)
    );
}


/**
 * Randomly assign one of the grid values to our goal color.
 */
gridColors.value[Phaser.Math.Between(0, gridColors.value.length - 1)] = color.value;

const container = ref();
const picker = ref();
const handleEnter = (componentName: GameTypes.PickerComponentName) => {
    if (componentName === 'ScrollingColorPicker'){
        game.clock.start(state.value.duration * 3);
        return;
    }

    game.clock.start(state.value.duration);
}

const leave = () => {
    return Promise.all([
        picker.value?.leave(),
        container?.value.leave()
    ]);
}

const handleColorSelected = async (c: chroma.Color) => {
    if (c.hex() === color.value.hex()){
        emit('next', <GameTypes.MatchCompleteData> {
            background: c
        });
        return;
    }
    emit('fail');
}

expose({
    leave
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GameContentArea, {
    ref_key: "container",
    ref: container,
    onSkip: _cache[0] || (_cache[0] = () => emit('next', { skipped: true }))
  }, {
    instruction: _withCtx(() => [
      _createElementVNode("div", {
        class: "k-color-text",
        style: _normalizeStyle({ background: _unref(color).hex() })
      }, [
        _createVNode(ContrastText, { color: _unref(color) }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["color"])
      ], 4)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(ColorPicker, {
          ref_key: "picker",
          ref: picker,
          colors: gridColors.value,
          onEnter: handleEnter,
          onSelect: handleColorSelected
        }, null, 8, ["colors"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})